<template>
  <v-menu
    ref="pickermenu"
    v-model="menu"
    offset-y
    :close-on-content-click="closeOnClick"
    max-width="290px"
    min-width="290px"
    :nudge-right="40"
    :disabled="disabled"
  >
    <template v-slot:activator="{ on }">
      <v-text-field
        v-model="dateFormatted"
        :label="label"
        readonly
        clearable
        prepend-icon="event"
        :disabled="disabled"
        v-on="on"
        @click:clear="dateValue = null"
      />
    </template>

    <v-date-picker
      v-model="dateValue"
      :allowed-dates="allowedDates"
      :first-day-of-week="1"
      no-title
      scrollable
      actions
    >
      <v-spacer />

      <v-btn
        text
        color="primary"
        @click="menu = false"
      >
        Close
      </v-btn>
    </v-date-picker>
  </v-menu>
</template>

<script>
import moment from 'moment'
import { mapGetters } from 'vuex'

export default {
  props: {
    allowedDates: {
      type: Function,
      default: null
    },
    closeOnClick: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      default: 'event'
    },
    label: {
      type: String,
      default: 'Date'
    },
    value: {
      type: [String, Object, Date],
      default: null
    }
  },
  data () {
    return {
      menu: false
    }
  },
  computed: {
    ...mapGetters('user', [ 'preferences' ]),
    dateFormatted: {
      get () {
        if (!this.value) {
          return null
        }
        return moment(this.value).format(this.preferences.dateFormat || 'D MMM YYYY')
      },
      set (val) {
        // if (val === null) {
        //   this.$emit('input', null)
        // }
      }
    },
    dateValue: {
      get () {
        return this.value
      },
      set (date) {
        this.$emit('input', date)
      }
    }
  }
}
</script>

<style>

</style>
